import { FormHelperText } from '@mui/material'
import React from 'react'

import { PRIVACY_POLICY_LINK } from 'utils/constants/Helpers'

const MarketingText = () => {
  return (
    <FormHelperText className="sms-opt-in-text">
      By signing up, you agree to receive marketing text messages from Heyday at
      the phone number you provided, including recurring automated promotional
      and personalized marketing text messages (e.g. cart reminders). Consent is
      not required for purchase. Reply HELP for help, STOP to cancel. Message
      frequency varies. Msg & data rates apply. View our{' '}
      <a href={PRIVACY_POLICY_LINK} target="_blank" rel="noreferrer">
        Privacy Policy and Terms of Use
      </a>
      {/**/}.
    </FormHelperText>
  )
}

export default React.memo(MarketingText)
